import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_141: DocMigration = {
  maxSchemaVersion: "0.0.141",
  description: "Drop shed roof system",
  apply(json: any) {
    const { roofSystems } = json;
    for (const roofSystemId in roofSystems) {
      if (roofSystems[roofSystemId].type === "SHED") {
        delete roofSystems[roofSystemId];
      }
    }

    return json;
  },
};

export default migration_0_0_141;
